import firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyCISYfLuI9QHohcehIOAJVHBIhrDTeySOM',
  authDomain: 'ajm-kohaku-home.firebaseapp.com',
  databaseURL: 'https://ajm-kohaku-home.firebaseio.com',
  projectId: 'ajm-kohaku-home',
  storageBucket: 'ajm-kohaku-home.appspot.com',
  messagingSenderId: '342578188680',
  appId: '1:342578188680:web:0b1024d76b9375e17baa3d',
  measurementId: 'G-1SJ0JE82YD',
}

firebase.initializeApp(config)
const db = firebase.firestore()
const auth = firebase.auth()
const resume = db.collection('resume').doc('Rd9oxf7pS03L4oReeCIs')

async function getSkills() {
  const snapshot = await resume.collection('skills').get()
  return snapshot.docs.map((doc) => doc.data())
}

async function getEducation() {
  const snapshot = await resume.collection('education').get()
  return snapshot.docs.map((doc) => doc.data())
}

async function getEmployment() {
  let employmentList = []
  resume
    .collection('employment')
    .get()
    .then((docs) => {
      docs.forEach((doc) => {
        let employment = doc.data()
        employment.id = doc.employId
        employment.positions = getPositions(doc.id)
        employmentList.push(employment)
      }
      )
    })
    .then(() => {
      employmentList.reverse()
    })
  return employmentList
}

function getPositions(id) {
  let positions = []
  resume
    .collection('employment')
    .doc(id)
    .collection('positions')
    .get()
    .then((snap) => {
      snap.forEach((doc) => {
        positions.push(doc.data())
      })
    })
    .then(() => {
      positions.sort((a, b) => {
        return a.jobId - b.jobId
      })
      positions.reverse()
    })
  return positions
}

export { db, auth, getEducation, getEmployment, getSkills }
